import React, { FC } from 'react';
import { Trans, useTranslation } from '@wix/fe-essentials-standalone';
import { Text, TextButton } from '@wix/design-system';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import s from './SingleUseLicense.module.scss';

type SingleUseLicenseProps = {
  textSize?: 'tiny' | 'small' | 'medium';
  isMobileView: boolean;
};

const SingleUseLicense: FC<SingleUseLicenseProps> = ({
  textSize = 'medium',
  isMobileView,
}) => {
  const { logBiClick } = useTemplateBi({ is_mobile: isMobileView });
  const { t } = useTranslation();

  return (
    <>
      <Trans
        i18nKey="marketplace.template-page.single-use-license-description"
        size={textSize}
      >
        <Text
          dataHook="single-use-license-description"
          size={textSize}
          secondary
        >
          1
          <TextButton
            secondary
            size={textSize}
            skin="dark"
            onClick={() => {
              logBiClick({ clickType: 'Single use license - view terms' });
              window.open(
                t('marketplace.template-page.single-use-license-link'),
                '_blank',
              );
            }}
            className={s.viewMoreBtn}
          >
            2
          </TextButton>
        </Text>
      </Trans>
    </>
  );
};

export default SingleUseLicense;
